import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message, Button } from 'antd';

import { removePageLeave } from '../../reducers/listeners/common';
import Config from '../../config';
import CONSTANT from '../../constant';
import History from '../../util/history';
import Emitter from '../../services/emitter';
import ProjectApi from '../../services/api/project';
import mElectronApi from '../../util/electron';
import Subscribe from '../../util/subscribe';

class Publish extends Component {

    constructor(props) {
        super(props);
        const obr = value => {
            console.log('订阅了是否有网络 ', value);
            this.networkStatus = value;
        };
        Subscribe.listen('network', obr);
    }

    handlePublishClick = () => {
        const self = this;
        const jumpToPublish = () => {
            const { project, account } = self.props;
            const { projectId } = project;
            const { isInternational } = account;
            removePageLeave();
            const env = isInternational ? 'en' : 'zh';
            location.href = `${Config.link.project_share[env]}${projectId}`;
        };
        this.handleSaveListMenuClick(jumpToPublish);
    };

    showSaveErrorMessage = () => {
        const { intlr } = this.props;
        const leftCon = intlr.messages['MENU.FILE.UPLOAD.FAIL'];
        const rightCon = intlr.messages['BUTTON.CLOSE.TEXT'];
        const style = {
            div: {
                display: 'inline-block'
            },
            secSpan: {
                margin: '0 5px'
            },
            lastSpan: {
                cursor: 'pointer'
            }
        };
        const msgDiv = <div className="upload-file" style={style.div}>
            <span>{leftCon}</span>
            <span className="mid-part" style={style.secSpan}>|</span>
            <span onClick={() => message.destroy()} style={style.lastSpan}>{rightCon}</span>
        </div>;
        message.error(msgDiv, 0);
    };

    handleSaveListMenuClick = callback => {
        const { showLoadingPage, saveStatus } = this.props.project;
        if (showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
            return;
        }
        callback = typeof callback === 'function' ? callback : undefined;
        const { account, intlr, project } = this.props;
        const { isLogin, isInternational } = account;
        const { isSelfProject, projectId, name } = project;
        if (this.networkStatus === 'offline') {
            this.showSaveErrorMessage();
            return;
        } else if (!isLogin) {
            History.replace('/login');
            return;
        }

        if (isSelfProject || isInternational) {
            Emitter.emit('SaveProject', false, 'web', {name}, callback);
        } else {
            Emitter.emit('SaveProject', false, 'web', {name: `${name}-${intlr.messages['MENU.FILE.ADAPT']}`, isSelfProject: false, isShare: true, projectId: ProjectApi.getCorrectId(projectId)}, () => {
                History.replace('/');
            });
        }
    };

    publish = () => {
        const { intlr, project, account } = this.props;
        const { isLogin } = account;
        let { projectId } = project;
        projectId = ProjectApi.getCorrectId(projectId);
        let { isSelfProject, isShare } = project;

        const publish = <Button
            onClick={() => {
                const { showLoadingPage, saveStatus } = this.props.project;
                if (showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
                    return;
                }
                this.handlePublishClick();
            }}
            className="editor-header-publish">
            <i className={`mblock-icon icon-fabu1`}></i>
            {intlr.messages['BUTTON.SHARE']}
        </Button>;
        const view_works = <Button
            onClick={() => {
                const { isInternational } = this.props.account;
                const { showLoadingPage } = this.props.project;
                const env = isInternational ? 'en' : 'zh';
                if (showLoadingPage) {
                    return;
                }
                mElectronApi.openLink(null, `${Config.link.project_view[env]}${projectId}`);
            }}
            className="editor-header-publish"
        >
            <i className={`mblock-icon icon-chakanzuopin`}></i>
            {intlr.messages['MENU.FILE.VIEW_WORKS']}
        </Button>;

        const elem = strategies[isLogin ? 'isLogin' : 'notLogin']({
            isSelfProject,
            isShare,
            view_works,
            publish,
            projectId
        });

        return elem;
    };

    render() {
        return <section className="header-cell user-publish-cell">
            {this.publish()}
        </section>;
    }
}

export default connect(state => ({
    project: state.project,
    account: state.account,
    intlr: state.intlr
}))(Publish);

const strategies = {
    'notLogin': (obj) => {
        const {
            projectId,
            view_works
        } = obj;

        return !projectId ? null : view_works;
    },

    'isLogin': (obj) => {
        return isSelfPro.after(notSelfPro)(obj);
    }
};

const isSelfPro = obj => {
    const {
        isSelfProject,
        isShare,
        view_works,
        publish
    } = obj;

    if (isSelfProject) {
        return isShare ? view_works : publish;
    }

    return false;
};

const notSelfPro = obj => {
    const {
        view_works,
    } = obj;

    return view_works;
};

Function.prototype.after = function(fn) {
    const self = this;
    return function() {
        var ret = self.apply(this, arguments);
        if (!ret) {
            return fn.apply(this, arguments);
        }
        return ret;
    };
};
